<template>
  <div>
    <!-- 新增字段 -->
    <el-form-item label="是否重点活动:" required>
      <div class="flexc-cen-x mt10">
        <el-radio-group
          v-model="radioKeyActivity"
          @input="isKeyActivityChange"
          :disabled="isDisabled"
        >
          <el-radio :label="0">否</el-radio>
          <el-radio :label="1">是</el-radio>
        </el-radio-group>
        <el-tooltip class="item" effect="dark" placement="top">
          <template slot="content">
            <div>
              大促、品牌高流量等活动建议选「是」，官方会有一定的技术保障资源倾斜
            </div>
          </template>
          <el-button type="text" style="width: 35px;">
            <i class="el-icon-question text-color"></i>
          </el-button>
        </el-tooltip>
      </div>
    </el-form-item>
    <el-form-item label="活动投放位置:" required>
      <el-checkbox-group
        v-model="checkLocationList"
        :disabled="isDisabled"
        @change="placementPositionChange"
      >
        <el-checkbox label="HOME">京东APP首场曝光位</el-checkbox>
        <el-checkbox label="CHANNEL">大促主会场资源</el-checkbox>
        <el-checkbox label="SEARCH_RECOMMEND">搜索与推荐链路</el-checkbox>
        <el-checkbox label="SHOP">店铺</el-checkbox>
        <el-checkbox label="OUTSIDE">域外曝光</el-checkbox>
        <el-checkbox label="OTHER">其他渠道</el-checkbox>
        <el-tooltip class="item" effect="dark" placement="bottom">
          <template slot="content">
            <div>上方选择为【是】时请选择活动投放位置便于官方监控流量</div>
          </template>
          <el-button type="text" style="width: 35px;">
            <i class="el-icon-question text-color"></i>
          </el-button>
        </el-tooltip>
      </el-checkbox-group>
    </el-form-item>
  </div>
</template>
<script>
export default {
  mixins: [],
  props: {
    activityData: {
      type: Object,
      default: () => {},
    },
    // 是否重点活动
    isKeyActivity: {
      type: Number,
      default: 0,
    },
    // 活动投放位置
    placementPosition: {
      type: Array,
      default: () => [],
    },
    valueRow: {
      type: Object,
      default: () => {},
    }
  },
  data() {
    return {
      radioKeyActivity: 0,
      checkLocationList: [],
    };
  },
  computed: {
    isDisabled() {
      // 未开始和进行中状态不能修改
      let flag = true;
      if(!this.valueRow) {
        flag = false
      }
      if(this.valueRow&&this.valueRow.status==5) {
        flag = false
      }
      if(this.activityData&&(this.activityData.isCopy||this.activityData.singleCopy)) {
        flag = false
      }
      if((this.activityData&&(this.activityData.id==8||this.activityData.id==19||this.activityData.id==50))&&this.activityData.status==5) {
        flag = false
      }
      if(this.activityData&&this.activityData.id==9&&this.activityData.isEdit) {
        flag = true
      }
      return flag
    },
  },
  watch: {
    isKeyActivity: {
      handler: function(v) {
        if (v != null || v != undefined) {
          this.radioKeyActivity = v ? 1 : 0;
        }
      },
      immediate: true,
    },
    placementPosition: {
      handler: function(v) {
        if (v != null || v != undefined) {
          this.checkLocationList = v;
        }
      },
      immediate: true,
    },
  },
  mounted() {},
  methods: {
    isKeyActivityChange(value) {
      this.$emit("update:isKeyActivity", value ? 1 : 0);
    },
    placementPositionChange(value) {
      this.$emit("update:placementPosition", value);
    },
  },
};
</script>
<style lang="scss" scoped>
.ml8 {
  margin-left: 8px;
}
.text-color {
  color: #ccc;
}
</style>
